import * as React from 'react';
import { connectSortBy } from 'react-instantsearch-dom';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const SortBy = ({ items , refine , currentRefinement  })=>{
    const selected = items.find((item)=>item.value === currentRefinement
    );
    const intl = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-sort"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "search-sort__sort-by-label"
    }, intl.getLabel('search.results.sort.sortBy'), /*#__PURE__*/ React.createElement("select", {
        className: "search-sort__select",
        value: currentRefinement,
        onChange: (evt)=>refine(evt.target.value)
    }, items.map((item)=>/*#__PURE__*/ React.createElement("option", {
            key: item.value,
            value: item.value,
            "aria-selected": selected && getLabel(selected) === getLabel(item)
        }, getLabel(item))
    ))), /*#__PURE__*/ React.createElement("div", {
        className: "search-sort__content"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "search-sort__sort-by"
    }, selected && getLabel(selected)), /*#__PURE__*/ React.createElement("span", {
        className: "search-sort__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down"
    }))));
    function getLabel(item) {
        const label = item.label ? item.label : item.labelKey ? intl.getLabel(item.labelKey) : '';
        if (!label) {
            console.error('A sort-item is missing both label as labelKey');
        }
        return label;
    }
};
var SortBy$1 = connectSortBy(SortBy);

export { SortBy$1 as default };
//# sourceMappingURL=SortBy.js.map
